export default (time, seconds) => {
    const diff = ((Date.now() - time) / 1000);
    return (diff > seconds);
}